import styled from "styled-components";
import * as mediaQuery from "components/MediaQuery";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";

export const Top = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  border-radius: 4px;
  padding: 20px;
  ${FLEX.FlexBetweenCenter};

  ${mediaQuery.isTablet} {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .refresh-button {
    :hover {
      > svg {
        path {
          fill: ${({ theme }) => theme.COLORS.WHITE};
        }
      }
    }
  }
`;

export const Header = styled.ul`
  ${FLEX.FlexStartStart};
  gap: 50px;
  flex: 4;

  ${mediaQuery.isMobile} {
    ${FLEX.FlexStartStart};
    gap: 18px;
    flex-direction: column;
  }
`;

export const HeaderItem = styled.li`
  ${FLEX.FlexStartStart};
  flex-direction: column;
  gap: 8px;

  h3 {
    font-size: ${calcRem(12)};
    font-weight: 600;
    color: ${({ theme }) => theme.COLORS.WHITE}70;
    text-transform: uppercase;
  }

  p {
    font-size: ${calcRem(16)};
    ${FLEX.FlexStartCenter};
    flex-wrap: wrap;
    gap: 4px;
    color: ${({ theme }) => theme.COLORS.WHITE};
  }

  ${mediaQuery.isMobile} {
    flex-direction: row;
    gap: 16px;
  }
`;

export const ButtonWrapper = styled.div`
  ${FLEX.FlexEndCenter};
  gap: 10px;

  ${mediaQuery.isDefault} {
    button {
      padding: 12px 10px;
      min-width: 100px;
    }
  }
`;
